// extracted by mini-css-extract-plugin
export default {"template":"IndexPage_template__KnXlg","mobile-wrapper":"IndexPage_mobile-wrapper__06vLR"};